import React from 'react';
import Block from 'ap-admin-components/lib/Components/Block';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import Login from '@/components/login/Login';
import { DefaultLayout } from '@/layout/DefaultLayout';
import { getRuntimeConfiguration, translationNamespace } from '@/lib/config';

export const getServerSideProps: GetServerSideProps = async (ctx) => ({
  props: {
    ...(await serverSideTranslations(ctx.locale!, translationNamespace)),
    hasError: !!ctx.query?.error,
  },
});

const LoginPage = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const router = useRouter();
  /* Login URL for Azure AD. */
  const loginUrl = `${getRuntimeConfiguration('CONFIGURATOR_API_URL')}/auth/login`;
  return (
    <DefaultLayout>
      <Block width="narrow">
        <Login
          onLogin={() => router.push(loginUrl)}
          hasError={props.hasError}
        />
      </Block>
    </DefaultLayout>
  );
};

export default LoginPage;
